import { PricingRegion } from '@/lib/pricingMatrix/PricingRegion'
import getPricingMatrix, { getSmsPricing, PriceCalculations } from '@/lib/pricingMatrix/PricingMatrix'

export const TimelyPlanName = {
  /** @deprecated The 'Basic' plan, previously called 'Start', is no longer available to new customers */
  BASIC: 'start',
  BUILD: 'build',
  ELEVATE: 'elevate',
  INNOVATE: 'innovate'
}

export const getPlanByPricingRegion = ({ pricingRegion, planId }) => {
  const _plansInfo = {
    [TimelyPlanName.BUILD]: {
      id: TimelyPlanName.BUILD,
      name: 'Build',
      description: 'For salons who want to simplify appointments and payments.',
      featured: false,
      cta: 'Try Build for free',
      features: {
        title: 'Key features:',
        list: []
      }
    },
    [TimelyPlanName.ELEVATE]: {
      id: TimelyPlanName.ELEVATE,
      name: 'Elevate',
      description: 'For salons who want to put their brand first and reduce admin.',
      featured: false,
      cta: 'Try Elevate for free',
      features: {
        title: 'Everything in Build, plus:',
        list: []
      }
    },
    [TimelyPlanName.INNOVATE]: {
      id: TimelyPlanName.INNOVATE,
      name: 'Innovate',
      description: 'For salons who want to transform and put the client experience first.',
      featured: true,
      cta: 'Try Innovate for free',
      features: {
        title: 'Everything in Elevate, plus:',
        list: []
      }
    }
  }

  if (planId === TimelyPlanName.BUILD) {
    _plansInfo[TimelyPlanName.BUILD].features.list.push(
      'Online and social media booking',
      'Send automated customer reminders with SMS and email'
    )
    if ([PricingRegion.NZL, PricingRegion.AUS, PricingRegion.GBR].includes(pricingRegion)) {
      _plansInfo[TimelyPlanName.BUILD].features.list.push('Seamless in-salon and online payments with simple fees')
    }

    if ([PricingRegion.IRL, PricingRegion.USA, PricingRegion.EUE].includes(pricingRegion)) {
      _plansInfo[TimelyPlanName.BUILD].features.list.push('Online payments with simple fees')
    }

    _plansInfo[TimelyPlanName.BUILD].features.list.push(
      'Manage stock levels'
    )
  }

  if (planId === TimelyPlanName.ELEVATE) {
    _plansInfo[TimelyPlanName.ELEVATE].features.list.push(
      'Send digital consultation forms',
      'Store client photos and documents ',
      'Waitlist to manage appointment requests and cancellations',
      'Targeted SMS campaigns and automated follow-up messages',
      'Set pricing tiers based on staff skills and seniority'
    )
  }

  if (planId === TimelyPlanName.INNOVATE) {
    if ([PricingRegion.NZL, PricingRegion.AUS, PricingRegion.GBR, PricingRegion.IRL].includes(pricingRegion)) {
      _plansInfo[TimelyPlanName.INNOVATE].features.list.push('Direct phone support')
    }

    _plansInfo[TimelyPlanName.INNOVATE].features.list.push(
      'Reduce admin with automatic consultation forms ',
      'Encourage rebooking with automated reminders',
      'Create and track staff sales targets and performance',
      'VIP services for special clients',
      'Send customers to a personalised booking confirmation page'
    )
  }

  return _plansInfo[planId]
}

const makeStaffCountNumber = (staffCount) => {
  const staffCountNumber = parseInt(staffCount)
  return isNaN(staffCountNumber) ? 1 : staffCountNumber === 0 ? 1 : staffCountNumber
}

const planPrice = getPricingMatrix()
const smsPricing = getSmsPricing()

export const getPlanPrice = ({ pricingRegion, planId, staffCount }) => {
  staffCount = makeStaffCountNumber(staffCount)
  const planPriceSms = smsPricing[pricingRegion]
  const planPriceCountry = planPrice[pricingRegion]

  const calculatePlanPrices = PriceCalculations(planPriceCountry)
  const priceType = staffCount === 1 ? 'solo' : staffCount >= 8 ? 'fixed' : 'staff'

  const freeSmsPerStaffPerMonth = planPriceSms?.freeSmsPerStaffPerMonth?.[planId] * staffCount

  let total = calculatePlanPrices({ plan: planId, staffCount })
  let price = 0

  if (priceType === 'fixed') {
    total = calculatePlanPrices({ plan: planId, staffCount })
    price = (total / staffCount).toFixed(2)
  } else {
    total = calculatePlanPrices({ plan: planId, staffCount })
    price = planPriceCountry.prices?.[priceType]?.[planId]
  }

  const isDisabled = (planId === TimelyPlanName.BUILD && staffCount > 7) || staffCount > 19

  return {
    isDisabled,
    priceTag: planPriceCountry.tag,
    currencyCode: planPriceCountry.currencyCode,
    sign: planPriceCountry.sign,
    price,
    total,
    freeSmsPerStaffPerMonth
  }
}
